import React, { useState, useEffect } from "react";
import DashboardSidebar from "../agencyDashboardSidebar";
import { SlidersHorizontal } from "lucide-react";

import { useParams } from "react-router-dom";
import { useProviderCompany } from "../../../../context/ProviderCompanyContext";

import Payments from "./payments";
import OfferConfig from "./offerConfigs/offerconfig" ;
import SSO from "./sso"; 
import APIVersion from "./apiversion"; 
import Branding from "./branding"; 

const TABS = [
  { key: "branding",    label: "Branding" },
  { key: "payments",    label: "Payments" },
  { key: "sso",         label: "SSO" },
  { key: "offer",       label: "Configurations" },
  { key: "api-version", label: "API Version" },
];

const Account = () => {
  const { providerCompanyId } = useParams();
  const { providerCompanyData, fetchProviderCompanyData } =
    useProviderCompany();

  const [activeTab, setActiveTab] = useState("branding");
  const [showSideDrawer, setShowSideDrawer] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (providerCompanyId) {
      fetchProviderCompanyData(providerCompanyId);
      setLoading(false);
    }
  }, []);

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50 font-inter">
      <DashboardSidebar isOpen={showSideDrawer} setIsOpen={setShowSideDrawer} />
      <main className="flex-1 overflow-hidden flex flex-col">

        {/* ── Page header + tab bar (sticky) ─────────────────── */}
        <div className="border-b border-gray-200 bg-white px-6 pt-6 pb-0">
          <div className="mb-5 flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
              <SlidersHorizontal size={20} className="text-primary" />
            </div>
            <div>
              <h1 className="text-xl font-semibold text-gray-900">Admin Console</h1>
              <p className="text-sm text-gray-500">Configure settings for your enterprise.</p>
            </div>
          </div>

          <nav className="-mb-px flex gap-1 overflow-x-auto">
            {TABS.map(({ key, label }) => (
              <button
                key={key}
                onClick={() => setActiveTab(key)}
                className={`flex items-center whitespace-nowrap border-b-2 px-4 py-2.5 text-sm font-medium transition-colors ${
                  activeTab === key
                    ? 'border-brand-pink text-brand-pink'
                    : 'border-transparent text-muted-foreground hover:border-gray-300 hover:text-foreground'
                }`}
              >
                {label}
              </button>
            ))}
          </nav>
        </div>

        {/* ── Scrollable content ──────────────────────────────── */}
        <div className="flex-1 overflow-y-auto p-6">
          {loading && (
            <div className="flex justify-center items-center py-16">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
            </div>
          )}
          {!loading && (
            <>
              {activeTab === "branding" && (
                <Branding providerCompanyId={providerCompanyId} providerCompanyData={providerCompanyData} />
              )}
              {activeTab === "payments" && <Payments />}
              {activeTab === "sso" && <SSO providerCompanyId={providerCompanyId} />}
              {activeTab === "offer" && (
                <OfferConfig providerCompanyId={providerCompanyId} providerCompanyData={providerCompanyData} />
              )}
              {activeTab === "api-version" && <APIVersion />}
            </>
          )}
        </div>
      </main>
    </div>
  );
};

export default Account;
